import { Storage } from '@ionic/storage'
import { Preferences } from '@capacitor/preferences';

const localStorage = new Storage()
localStorage.create()

const StorageService = {
    set: async(keyName: string, data: any) => {
        await localStorage.set(keyName, data)
    },
    get: async (keyName: string) => {
        return await localStorage.get(keyName)
    },
    remove: async (keyName: string) => {
        await localStorage.remove(keyName);
    },
    clear: async () => {
        await localStorage.clear();
        await clearPreferences()
    },
    keys: async () => {
       return await localStorage.keys();
    },
    // access_tokenはcapacitorのPreferencesに保存する
    setAccessToken: async(value: string) => {
        await setPreferences('access_token', value)
    },
    getAccessToken: async() => {
        return await getPreferences('access_token')
    },
    removeAccessToken: async() => {
        await removePreferences('access_token')
    },
    clearAccessToken: async () => {
        await clearPreferences()
    },
    // b→dash連携用scrambled_idをPreferencesに保存する
    setScrambledId: async(value: number) => {
        await setPreferences('scrambled_id', String(value))
    },
    getScrambledId: async(): Promise<number | null> => {
        const value = await getPreferences('scrambled_id')
        if (value === null) return null
        const numValue = Number(value)
        return isNaN(numValue) ? null : numValue
    },
    removeScrambledId: async() => {
        await removePreferences('scrambled_id')
    },
    // b→dash連携用barcode_numberをPreferencesに保存する
    setBarcodeNumber: async(value: string) => {
        await setPreferences('barcode_number', value)
    },
    getBarcodeNumber: async(): Promise<string | null> => {
        return await getPreferences('barcode_number')
    },
    removeBarcodeNumber: async() => {
        await removePreferences('barcode_number')
    },
}

const setPreferences = async (key: string, value: string) => {
    await Preferences.set({
        key: key,
        value: value,
    });
};
const getPreferences = async (key:string) => {
    const { value } = await Preferences.get({ key: key });
    return value
};
const removePreferences = async (key: string) => {
    await Preferences.remove({ key: key });
};
const clearPreferences = async () => {
    await Preferences.clear();
}


export default StorageService
